import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import * as mixpanel from "core/integrations/mixpanel";
import * as fbPixel from "core/integrations/fb_pixel";
import * as dataLayer from "core/integrations/gtm";
import logo from "./assets/logo.svg";
import { candidate } from "routes/paths";

export default () => (
  <Wrap>
    <Body>
      <IconWrap>
        <Icon />
      </IconWrap>
      <div>
        <Title>Not sure who to speak with?</Title>
        <Desc>Book a 15 min consultation with The Lobby team.</Desc>
      </div>
      <Button
        to={candidate.consultation}
        onClick={() => {
          fbPixel.fbq("trackCustom", "BookConsultation");
          dataLayer.push({
            event: "BookConsultation"
          });
          mixpanel.trackEvent("Book Consultation Clicked");
        }}
      >
        Book consultation
      </Button>
    </Body>
  </Wrap>
);

const IconWrap = styled.div`
  width: 115px;
  height: 115px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 3rem;
  background-color: #fbfaf9;
  @media (max-width: 768px) {
    margin-right: 0;
    margin-bottom: 1rem;
  }
`;

const Button = styled(Link)`
  border-radius: 1000px;
  border: 2px solid #000;
  text-transform: uppercase;
  font-size: 1rem;
  font-family: "CircularStd-Book", sans-serif;
  margin-left: auto;
  cursor: pointer;
  text-decoration: none;
  color: #000;
  padding: 1rem 2rem;
  @media (max-width: 768px) {
    margin-top: 2rem;
    margin-left: 0;
  }
`;

const Icon = styled.img.attrs({
  src: logo
})`
  width: 2rem;
`;

const Title = styled.div`
  font-size: 2.25rem;
  font-family: TiemposHeadlineWeb;
  font-weight: 400;
  @media (max-width: 768px) {
    margin-bottom: 1rem;
  }
`;

const Desc = styled.div`
  font-family: "CircularStd-Book", sans-serif;
  font-size: 1.25rem;
`;

const Body = styled.div`
  background-color: #fff;
  margin: 1.75rem 0 2.75rem;
  padding: 4.125rem 3.4375rem;
  align-items: center;
  display: flex;
  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const Wrap = styled.div`
  position: relative;
  margin: 0 -100px;
  z-index: 1;
  &:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 15px;
    left: 15px;
    z-index: -1;
    background-color: #ebe8e1;
  }
  @media (max-width: 1180px) {
    margin: 0;
  }
  @media (max-width: 768px) {
    &:after {
      display: none;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/Candidate/InsidersList/internal/Consultation/index.js